import { INotificationBar } from "@/components/elements/languages/NotificationBar";

export type Language = {
    languageId: number;
    name: string;
    languageCode: string;
    isSupported: boolean;
    enabled:boolean;
    imageUrl:string;
    settingsSaved?:boolean;
    localisationOrganisationId: number;
    flagRegionCode: string;
}

export enum ProgressBar {
    languageSelection = "languageSelection",
    languageAction = "languageAction",
    review = "review"
}

export enum LanguageSettingOption {
    'manual' ,
    'automatic'
}

export enum TranslateScope {
    'AllContent',
    'TranslatedContent'
}

export enum NotificationStatus {
    success = "success",
    error = "error",
    null = "null"
}

export interface ILanguagesTab {
    show: boolean,
    setDctEnabled:(enabled: boolean)=>void,
    dctEnabled: boolean,
    setQuickTranslateDisabled: (isDisabled: boolean)=>void,
    toggleNotification: (bar:INotificationBar)=>void
}

export interface IDoNotTranslateTab {
    show?: boolean,
}

export enum LanguageTabs {
    'language' ,
    'doNotTranslate'
}

export interface IWhitelistTerm {
    id: number,
    text: string,
    description?: string
}

export interface IAddTermModal {
    showModal: boolean,
    termInformation: IWhitelistTerm | null,
    onSaveClick: (newTerm: any)=>void,
    onCloseClick: ()=>void
}

export interface IRemoveTermModal {
    showModal: boolean,
    setRemoveTermItem: ()=>void,
    onConfirmClick: ()=>void
}
export interface ILanguageMapperList {
    languages:Language[],
    dctEnabled: boolean
    handleChecked: (language: Language)=>void,
    settingsSelected: (language: Language)=>void
}